import { render, staticRenderFns } from "./newCollecte.vue?vue&type=template&id=3043578b&scoped=true"
import script from "./newCollecte.vue?vue&type=script&lang=js"
export * from "./newCollecte.vue?vue&type=script&lang=js"
import style0 from "./newCollecte.vue?vue&type=style&index=0&id=3043578b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3043578b",
  null
  
)

export default component.exports